import axios from 'axios';

export default async function deleteReply(
  accessToken,
  userId,
  locationId,
  reviewId,
  setIsFetching,
) {
  const requestOptions = {
    headers: {
      'access-token': accessToken,
    },
  };

  if (setIsFetching) setIsFetching(true);

  try {
    const { data } = await axios.delete(
      `${process.env.REACT_APP_GOOGLE_API_URL}/delete-reply/${userId}/${locationId}/${reviewId}`,
      requestOptions,
    );

    return data;
  } catch (err) {
    return err.response;
  } finally {
    setIsFetching(false);
  }
}
